import React from 'react';

import { NavLinkButton } from '@shared/components/bootstrap';
import { UserRole } from '@shared/types/user_role';

import { Panel as SharedPanel } from '@admin/components/helpers/panel';
import { Roles } from '@admin/components/helpers/roles';
import { Spinner } from '@admin/components/spinner';
import { newPaymentPlanOfferURL } from '@admin/config/routes';
import { client } from '@admin/libraries/apollo';
import { useAccountPaymentPlanOffersQuery, PaymentPlan__Offer__State as OfferState } from '@admin/schema';

import { Table } from './table';

const OPEN_OFFER_STATES = [OfferState.Draft, OfferState.Approved];

export const PaymentPlansPanel: React.FC<{
  accountID: string;
}> = ({ accountID }) => {
  const { data, loading } = useAccountPaymentPlanOffersQuery({ variables: { accountID }, client });

  const offers = data && data.offers;

  const openOffersExist = offers && offers.some((offer) => OPEN_OFFER_STATES.includes(offer.state) && !offer.expired);

  return (
    <>
      <SharedPanel>
        <SharedPanel.Header>
          <SharedPanel.Title>Payment Plans</SharedPanel.Title>
        </SharedPanel.Header>
        <SharedPanel.Body>
          {loading && <Spinner />}
          {offers && <Table accountID={accountID} offers={offers} />}
        </SharedPanel.Body>
        {!openOffersExist && (
          <Roles show={[UserRole.Admin, UserRole.Collections]}>
            <SharedPanel.Footer align="right">
              <NavLinkButton kind="primary" to={newPaymentPlanOfferURL({ accountID })}>
                Create New Payment Plan
              </NavLinkButton>
            </SharedPanel.Footer>
          </Roles>
        )}
      </SharedPanel>
    </>
  );
};
